// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The link itself */
.modal-link-button {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    text-decoration: none;
    color: inherit;
    background-color: transparent;
    border: none;
    font-size: 0.95rem;
}

@media (hover: hover) and (pointer: fine) {
    .modal-link-button:hover {
        text-decoration: underline;
    }
}

    .modal-link-button.active {
        text-decoration: underline;
    }

    /* Ensure the modal content scrolls vertically */
    .modal-link-body {
        overflow-y: auto;
        max-height: calc(85vh - 60px); /* subtract header height */
        padding-right: 1rem; /* avoid scrollbar overlap */
    }
`, "",{"version":3,"sources":["webpack://./src/Controls/Button/css/ModalLinkButton.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;IAEI;QACI,0BAA0B;IAC9B;;IAEA,gDAAgD;IAChD;QACI,gBAAgB;QAChB,6BAA6B,EAAE,2BAA2B;QAC1D,mBAAmB,EAAE,4BAA4B;IACrD","sourcesContent":["/* The link itself */\r\n.modal-link-button {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    color: inherit;\r\n    background-color: transparent;\r\n    border: none;\r\n    font-size: 0.95rem;\r\n}\r\n\r\n@media (hover: hover) and (pointer: fine) {\r\n    .modal-link-button:hover {\r\n        text-decoration: underline;\r\n    }\r\n}\r\n\r\n    .modal-link-button.active {\r\n        text-decoration: underline;\r\n    }\r\n\r\n    /* Ensure the modal content scrolls vertically */\r\n    .modal-link-body {\r\n        overflow-y: auto;\r\n        max-height: calc(85vh - 60px); /* subtract header height */\r\n        padding-right: 1rem; /* avoid scrollbar overlap */\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
